// extracted by mini-css-extract-plugin
export default {"statusLine":"styles_statusLine__GJ4aX","small":"styles_small__xNAVa"};